import React, { useState, useEffect, useRef } from "react";
import "../Styles/StatsCounter.css";

function AnimatedNumber({ target, suffix = "" }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started) return;
    const duration = 2000;
    const steps = 50;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [started, target]);

  return <span ref={ref}>{count}{suffix}</span>;
}

function StatsCounter() {
  return (
    <section className="stats-section">
      <div className="stats-inner">
        <div className="stat-item">
          <div className="stat-number">
            <AnimatedNumber target={15} suffix="+" />
          </div>
          <p className="stat-title">Years Experience</p>
          <p className="stat-desc">Industry expertise you can trust</p>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <div className="stat-number">
            <AnimatedNumber target={500} suffix="+" />
          </div>
          <p className="stat-title">Projects Completed</p>
          <p className="stat-desc">Residential & commercial</p>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <div className="stat-number">
            <AnimatedNumber target={100} suffix="%" />
          </div>
          <p className="stat-title">Client Satisfaction</p>
          <p className="stat-desc">Happy customers every time</p>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <div className="stat-number">
            <AnimatedNumber target={24} suffix="/7" />
          </div>
          <p className="stat-title">Support Available</p>
          <p className="stat-desc">We're always here for you</p>
        </div>
      </div>
    </section>
  );
}

export default StatsCounter;
